export interface FormState<T> {
  loading: boolean;
  item: T; // loaded item
}
